import React from "react";
import { useParams } from "react-router-dom";
import Header from "../../../components/Header";
import Footer from "../../../components/Footer";
import Breadcrumb from "../../../Breadcrumb";
import { Helmet } from "react-helmet-async";
import bannerIMG from "../../../../src/assets/bannerImages/main-img.jpg";
// import bannerIMG from "../../../../src/assets/bannerImages/main-img.jpeg";
import childImg1 from "../../../assets/img/child-img/indoor playground square fit 1.png";
import childImg2 from "../../../assets/img/child-img/indoor playground square fit 2.png";
import childImg3 from "../../../assets/img/child-img/indoor playground square fit 3.png";
import childImg4 from "../../../assets/img/child-img/indoor playground square fit 4.png";
import WhatsappButton from "../../../components/WhatsappButton";
import { Link } from "react-router-dom";
import plusicon from "../../../assets/img/product_img/plusicon.png";

const ProductsClimbing = () => {
  const { type } = useParams();
  console.log(type);
  let content;
  if (type === "KidsClimbingWall")
    content = (
  
      <div className="p-container">
         <div className="p-img-box" style={{ position: "relative", display: "inline-block" }}>
  <div
    className="breadcrumb-overlay"
    style={{
      position: "absolute",
      top:'110%',
      left: "20%",
      transform: "translate(-50%, -50%)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
    }}
  >
<Breadcrumb textColor="#000" />
</div>
<img src={bannerIMG} alt="soft play" className="main-img"></img>
  
</div>


        <h1 className="p-heading">Kids Climbing Wall</h1>
        <div className="p-heading-p-heading">
     <div className="p-heading-p-text">
 
      <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
        Welcome to our Kids Climbing Wall—a thrilling yet secure climbing
          experience at our indoor playground! Designed by Global Entertainment
          Manufacturer, a leading name in premium-quality indoor playgrounds,
          our climbing wall combines excitement, safety, and durability for an
          unforgettable adventure. Perfect for kids of all ages, our wall
          features colorful holds, varying difficulty levels, and top-notch
          safety measures to ensure a fun and worry-free experience.
      </h2>

     </div>
     </div>
        <div className="p-content-box">
          <div className="p-mini-content-1">
         
            <h3 className="p-sub-heading-2">
            Why Kids Love It
          </h3>
            <ul typeof="text-box">
             
              <li className="p-text-2">
              <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
                GEM’s Soft Play Area combines the excitement of a trampoline park with thoughtfully designed soft play equipment. Our play structures include:
              </h2>
              </li>
              
              <li className="p-text-2">
                <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
                  <b>Exciting Challenges</b>: Fun routes and grips keep kids engaged.
                </h2>
              </li>
              <li className="p-text-2">
                <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
                  <b>Builds Confidence</b>: Improves strength, coordination, and problem-solving.
                </h2>
              </li>
              <li className="p-text-2">
                <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
                  <b>TSocial Fun</b>: Great for group play and teamwork.
                </h2>
              </li>
            </ul>
            
           
            <h3 className="p-sub-heading-2">
            Safety First
            </h3>
    
              <ul typeof="text-box">
              <li className="p-text-2">
                <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
                  <b>Automatic Belay Device</b>: Safely lowers kids if they let go or reach the top.
                </h2>
              </li>
              <li className="p-text-2">
                <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
                  <b>Premium Materials</b>: Made with durable, non-toxic materials and soft landing mats.
                </h2>
              </li>
              <li className="p-text-2">
                <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
                  <b>Safety Gear</b>: Harnesses and helmets provided for every child.
                </h2>
              </li>
           
            </ul>
            
            <h3 className="p-sub-heading-2">
             How It Works
            </h3>
            <ul typeof="text-box">
              <li className="p-text-2">
                <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
                  Check in and gear up with our team.
                </h2>
              </li>
              <li className="p-text-2">
                <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
                  <b>Climb with confidence</b> — automatic belay ensures safety.
                </h2>
              </li>
              <li className="p-text-2">
                <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
                  Celebrate as your child conquers the wall!
                </h2>
              </li>
              
    
              <li className="p-text-2">
                <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
                  As a Global Entertainment Manufacturer, we pride ourselves on delivering premium quality indoor playgrounds that prioritize safety, innovation, and fun.
                </h2>
              </li>
              <li className="p-text-2">
                <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
                  Our Kids Climbing Wall is designed for Indoor Playground.
                </h2>
              </li>
           </ul>
          </div>

          <div className="p-mini-content-2">
            <div className="p-img-right-box">
              <img src={childImg1} alt="trampoline company" />
              <img src={childImg3} alt="trampoline parks" />{" "}
            </div>
            <div className="p-img-left-box">
              <img src={childImg2} alt="trampoline park with soft play" />
              <img src={childImg4} alt="soft play and trampoline" />
            </div>
          </div>
        </div>
      </div>
    );

  if (type === "AdultClimbingWall") {
    content = (
      <div className="p-container">
          <div className="p-img-box" style={{ position: "relative", display: "inline-block" }}>
  <div
    className="breadcrumb-overlay"
    style={{
      position: "absolute",
      top:'110%',
      left: "20%",
      transform: "translate(-50%, -50%)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
    }}
  >
<Breadcrumb textColor="#000" />
</div>
<img src={bannerIMG} alt="soft play and trampoline" className="main-img"></img>
</div>

        <h1 className="p-heading">Adults Climbing Wall</h1>
        <div className="p-heading-p-heading">
      <div className="p-heading-p-text">
        <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
          Step into the thrill of vertical adventure with our Adult Climbing Wall—an exciting and safe climbing experience designed exclusively for adults at our indoor playground. As a leading Trampoline Park Manufacturer in Jordan, we ensure our climbing walls feature a variety of challenging routes, premium safety features, and top-quality materials for a rewarding and secure climb.
        </h2>
      </div>
      </div>
        <div className="p-content-box">
          <div className="p-mini-content-1">
        
            <h3 className="p-sub-heading-2">Why You’ll Love It</h3>
            <ul typeof="text-box">
        
              <li className="p-text-2">
                <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
                  <b>Thrilling Challenges</b>: Multiple routes with varying difficulty levels to test your strength and skills.
                </h2>
              </li>
              <li className="p-text-2">
                <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
                  <b>Fitness & Fun</b>: A full-body workout that improves strength, endurance, and mental focus.
                </h2>
              </li>
              <li className="p-text-2">
                <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
                  <b>Social Experience</b>: Perfect for group outings, team-building events, or solo adventures.
                </h2>
              </li>
            </ul>
      
           
            <h3 className="p-sub-heading-2">
            Safety First
          </h3>
          <ul typeof="text-box">
              <li className="p-text-2">
                <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
                  <b>Automatic Belay Device</b>: Our advanced belay system ensures a smooth and controlled descent, eliminating the need for manual belaying and reducing risks.
                </h2>
              </li>
              <li className="p-text-2">
                <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
                  <b>Premium Materials</b>: The wall is built with high-quality, durable materials, including non-toxic holds and reinforced structures for maximum safety.
                </h2>
              </li>
              <li className="p-text-2">
                <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
                  <b>Safety Gear</b>: We provide harnesses and helmets designed for adult climbers, ensuring a secure fit and comfort.
                </h2>
              </li>
              <li className="p-text-2">
                <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
                  <b>Soft Landing Surfaces</b>: Thick, cushioned mats at the base of the wall provide a safe landing in case of a fall.
                </h2>
              </li>
            </ul>
            
            <h3 className="p-sub-heading-2">
            How It Works
          </h3>
          <ul typeof="text-box">
              <li className="p-text-2">
                <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
                  <b>Check-In</b>:  Arrive at our climbing area and check in with our staff.
                </h2>
              </li>
              <li className="p-text-2">
                <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
                  <b>Gear Up</b>: Get fitted with a harness and helmet, and receive a quick safety briefing.
                </h2>
              </li>
              <li className="p-text-2">
                <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
                  <b>Climb & Conquer</b>: Choose your route and start climbing our automatic belay system has you covered!
                </h2>
              </li>
              <li className="p-text-2">
                <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
                  <b>Celebrate</b>: Push your limits, reach new heights, and enjoy the thrill of accomplishment!
                </h2>
              </li>
            </ul>
            <h3 className="p-sub-heading-2">
            Why Choose Us?
          </h3>
          <ul typeof="text-box">
          <li className="p-text-2">
            <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
              As a global entertainment manufacturer, we specialize in creating premium-quality indoor playgrounds and climbing walls that combine innovation, safety, and durability. Our Adult Climbing Wall is designed to provide an exhilarating yet secure experience for all skill levels.
            </h2>
            </li>
            </ul>
          </div>

          <div className="p-mini-content-2">
            <div className="p-img-right-box">
              <img src={childImg1} alt="trampoline parks" />
              <img src={childImg3} alt="indoor family entertainment center" />{" "}
            </div>
            <div className="p-img-left-box">
              <img src={childImg2} alt="indoor playground design" />
              <img src={childImg4} alt="indoor play equipment commercial" />
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (type === "SpiderTower") {
    content = (
      <div className="p-container">
         <div className="p-img-box" style={{ position: "relative", display: "inline-block" }}>
  <div
    className="breadcrumb-overlay"
    style={{
      position: "absolute",
      top:'110%',
      left: "20%",
      transform: "translate(-50%, -50%)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
    }}
  >
<Breadcrumb textColor="#000" />
</div>
<img src={bannerIMG} alt="No-img" className="main-img"></img>
</div>
  <h1 className="p-heading">Spider Tower</h1>

        <div className="p-heading-p-heading">
      <div className="p-heading-p-text">
        <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
          At Global Entertainment Manufacturer, we bring the thrill of climbing to indoor playgrounds with our Spider Tower—a fun, safe, and interactive play structure designed to challenge and excite kids of all ages.
        </h2>
      </div>
      </div>
        <div className="p-content-box">
          <div className="p-mini-content-1">
            <h3 className="p-sub-heading-2">What is the Spider Tower?</h3>
            <ul typeof="text-box">
              <li className="p-text-2">
              <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
              The Spider Tower is a multi-level climbing attraction featuring elastic webbing layers that kids can climb through, jump on, and crawl between.
              </h2>
              </li>
              <li className="p-text-2">
              <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
              It provides a unique climbing experience that promotes adventure, balance, and coordination in a completely safe environment. 
              </h2>
              </li>
              </ul>
            <h3 className="p-sub-heading-2">
            Key Features & Safety Measures:
            </h3>
          <ul typeof="text-box">
              <li className="p-text-2">
                <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
                  <b>High-Quality, Soft & Durable Materials</b> – Elastic webbing made from strong yet flexible materials for a secure climb
                </h2>
              </li>
              <li className="p-text-2">
                <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
                  <b>Fully Enclosed Design</b>: – Prevents accidental falls while ensuring maximum safety
                </h2>
              </li>
              <li className="p-text-2">
                <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
                  <b>Padded Landing Zones</b> – Soft, cushioned floors for extra protection
                </h2>
              </li>
              <li className="p-text-2">
                <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
                  <b>Non-Toxic, Fire-Retardant Materials</b> – Safe for children, built to last
                </h2>
              </li>
              <li className="p-text-2">
                <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
                  <b>Customizable Themes & Sizes</b> – Designed to match any indoor playground setup
                </h2>
              </li>
            </ul>

            <h3 className="p-sub-heading-2">Why Choose Our Spider Tower?</h3>
              
     
              <ul typeof="text-box">
              <li className="p-text-2">
                <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
                  <b>Encourages Physical & Mental Skills</b> – Develops strength, agility, and problem-solving abilities
                </h2>
              </li>{" "}
              <li className="p-text-2">
                <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
                  <b>Safe & Low Maintenance</b> – Requires no harnesses or safety gear, making it an easy and efficient play option
                </h2>
              </li>
              <li className="p-text-2">
                <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
                  <b>Ideal for Indoor Playgrounds</b> – Perfect for malls, FECs, and entertainment centers
                </h2>
              </li>
            </ul>
          </div>

          <div className="p-mini-content-2">
            <div className="p-img-right-box">
              <img src={childImg1} alt="playground equipment company" />
              <img src={childImg3} alt="soft play" />{" "}
            </div>
            <div className="p-img-left-box">
              <img src={childImg2} alt="playgrounds and parks" />
              <img src={childImg4} alt="indoor playground with slide" />
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <Helmet>
                    <meta name="playground equipment company" content="GEM is a top-rated trampoline company, offering the highest quality 
trampolines for safety, durability, and endless fun. Perfect for any 
backyard adventure" />

<meta name="soft play installation" content="GEM offers the highest quality trampolines with expert soft play 
installation for safe, fun, and durable play spaces. Perfect for 
homes and commercial setups." />


<meta name="indoor commercial playground" content="Discover GEM, the highest quality trampoline designed for ultimate
 fun and safety. Perfect for soft play areas, providing hours of joy and
 excitement for all ages." />
                  </Helmet>
      <Header />
        <div>
        {/* Whats App Icon */}
        <WhatsappButton
            altText="Chat with us on WhatsApp"
            iconSize={70}
          />
        <Link
          to="/getquotations"
          style={{ textDecoration: "none", color: "inherit" }}
        >
          <div className="icon-container">
            <img
              src={plusicon}
              alt="playground equipment suppliers"
              className="Producticon"
              style={{ cursor: "pointer" }}
            />
            <button className="quotation-button">Get Quotation</button>
          </div>
        </Link>
      </div>
      {content}
      <Footer />
    </div>
  );
};
export default ProductsClimbing;
